import React, {FC, useEffect, useState} from 'react'
import { BranchTable } from './components/BranchTable';
import axios from 'axios'

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_BRANCHES_URL = `${API_URL_API}/branch`


const BranchListPage: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [branches, setBranches] = useState([]);


  useEffect(() => {
    getAllBranches();
  },[])


  const getAllBranches = async () => {
    
    try {
      const {data: result} = await axios.get(GET_ALL_BRANCHES_URL);
        setBranches(result.data);
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
            <BranchTable branches={branches} getAllBranches={getAllBranches} className='mb-5 mb-xl-8' />
          )
        }

          
        </>
  )
}

export {BranchListPage}
